import type { IAttributes, IScope } from 'angular';

const ngEnter = () => (scope: IScope, element: JQLite, attrs: IAttributes) => {
  element.bind('keydown keypress', event => {
    if (event.which === 13) {
      scope.$apply(() => {
        scope.$eval(attrs.ngEnter, { event });
      });

      event.preventDefault();
    }
  });
};

export default ngEnter;
